import { components } from "react-select";
import { ArrowDownIcon } from "app/icons/navigation";

const DropdownIndicator = props => {
	return (
		<components.DropdownIndicator {...props}>
			<ArrowDownIcon height={12} width={12} />
		</components.DropdownIndicator>
	);
};

export default DropdownIndicator;
